/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import {
  AccordionContainer,
  BannerLayered,
  BrandRibbon,
  CardCarouselContainer,
  CardHorizontalFeature,
  CardHorizontalMini,
  CardLayered,
  CardVertical,
  EditableHTLWrapper,
  Hero,
  LinkList,
  RichText,
  StaticWrapper,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  Footer,
} from '@marriott/mi-common-static-components';
import {
  AssociateHeader,
  AssociateLogin,
  BulletinBoard,
  ConfirmEventSummary,
  ContactInfo,
  CreateEventSummary,
  DashboardContentTiles,
  EventDetails,
  EventHeading,
  EventList,
  EventProfile,
  EventSearch,
  EventSpaces,
  EventSummaryList,
  GeneralError,
  GeneralMessage,
  GroupSearchFormDynamic,
  GroupSearchForm,
  SearchFormDynamic,
  SearchForm,
  GuestRooms,
  ImageBanner,
  IntlRfpEventInfo,
  IntlRfpHeader,
  ModifyEventSummary,
  NavigationMenu,
  PaymentInfo,
  PlannerEventList,
  PlannerHeader,
  PlannerLogin,
  PlannerNewEvent,
  PreferredPaymentConfirmation,
  PreferredPaymentHeader,
  PreferredPaymentInfo,
  PropertyHeader,
  QuickGroupHeader,
  ReslinkAssociateHeader,
  ReslinkDashboardContentTiles,
  ReslinkEmailInfo,
  ReslinkEventDetails,
  ReslinkGuest,
  ReslinkSearchAndFilter,
  Review,
  RfpConfirmation,
  RfpHeader,
  RfpTray,
  SearchAndFilter,
  SearchResults,
  SubmitInquiry,
  BillingAndContact,
  QuickGroupConfirmation,
  InvalidSession,
  EventConfirmationDetails,
  ResubmitRfp,
} from '@marriott/mi-groups-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { HeroBanner } from '@marriott/mi-homepage-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { Heading, Text } from '@marriott/mi-ui-library';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/text`]: Text,
  [`mi-aem-common-spa/components/title`]: Heading,
  [`mi-aem-common-spa/components/image`]: Container,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-groups/components/content/shoppingpages/sectionnavigation`]: NavigationMenu,
  [`mi-aem-groups/components/content/shoppingpages/imagebanner`]: ImageBanner,
  [`mi-aem-groups/components/content/groupsearchform`]: GroupSearchForm,
  [`mi-aem-groups/components/content/groupsearch/searchresultsv2`]: SearchForm,
  [`mi-aem-groups/components/content/groupsearch/searchresults`]: SearchResults,
  [`mi-aem-groups/components/content/rfp/rfptray`]: RfpTray,
  [`mi-aem-groups/components/content/rfp/header`]: RfpHeader,
  [`mi-aem-groups/components/content/rfp/eventprofile`]: EventProfile,
  [`mi-aem-groups/components/content/rfp/eventdetails`]: EventDetails,
  [`mi-aem-groups/components/content/rfp/contactinformation`]: ContactInfo,
  [`mi-aem-groups/components/content/rfp/confirmation`]: RfpConfirmation,
  [`mi-aem-groups/components/content/rfp/eventinfoheader`]: IntlRfpHeader,
  [`mi-aem-groups/components/content/rfp/eventinfo`]: IntlRfpEventInfo,
  [`mi-aem-groups/components/content/rfp/paymentheader`]: PreferredPaymentHeader,
  [`mi-aem-groups/components/content/rfp/preferredpayment`]: PreferredPaymentInfo,
  [`mi-aem-groups/components/content/rfp/cardInformation`]: PaymentInfo,
  [`mi-aem-groups/components/content/rfp/preferredpaymentconfirmation`]: PreferredPaymentConfirmation,
  [`mi-aem-groups/components/content/roominglist/associateheader`]: AssociateHeader,
  [`mi-aem-groups/components/content/roominglist/roominglistlogin`]: AssociateLogin,
  [`mi-aem-groups/components/content/roominglist/contenttiles`]: DashboardContentTiles,
  [`mi-aem-groups/components/content/roominglist/searchandfilters`]: SearchAndFilter,
  [`mi-aem-groups/components/content/roominglist/createeventsummary`]: CreateEventSummary,
  [`mi-aem-groups/components/content/roominglist/modifyeventsummary`]: ModifyEventSummary,
  [`mi-aem-groups/components/content/roominglist/eventsummarylist`]: EventSummaryList,
  [`mi-aem-groups/components/content/roominglist/revieweventsummary`]: ConfirmEventSummary,
  [`mi-aem-groups/components/content/roominglist/planner/plannerheader`]: PlannerHeader,
  [`mi-aem-groups/components/content/roominglist/planner/plannerlogin`]: PlannerLogin,
  [`mi-aem-groups/components/content/roominglist/planner/eventheading`]: EventHeading,
  [`mi-aem-groups/components/content/roominglist/planner/search`]: EventSearch,
  [`mi-aem-groups/components/content/roominglist/planner/plannereventlist`]: PlannerEventList,
  [`mi-aem-groups/components/content/roominglist/planner/plannernewevent`]: PlannerNewEvent,
  [`mi-aem-groups/components/content/roominglist/notification`]: BulletinBoard,
  [`mi-aem-groups/components/content/reslink/reslinkguest`]: ReslinkGuest,
  [`mi-aem-groups/components/content/reslink/reslinkheader`]: ReslinkAssociateHeader,
  [`mi-aem-groups/components/content/reslink/contenttile`]: ReslinkDashboardContentTiles,
  [`mi-aem-groups/components/content/reslink/searchandfilters`]: ReslinkSearchAndFilter,
  [`mi-aem-groups/components/content/reslink/reslinklist`]: EventList,
  [`mi-aem-groups/components/content/reslink/eventdetails`]: ReslinkEventDetails,
  [`mi-aem-groups/components/content/common/emailform`]: ReslinkEmailInfo,
  [`mi-aem-groups/components/content/common/generalerror`]: GeneralError,
  [`mi-aem-groups/components/content/common/reslinksubmitinvalid`]: GeneralMessage,
  [`mi-aem-groups/components/content/quickgroup/propertycardheader`]: PropertyHeader,
  [`mi-aem-groups/components/content/quickgroup/header`]: QuickGroupHeader,
  [`mi-aem-groups/components/content/quickgroup/guestrooms`]: GuestRooms,
  [`mi-aem-groups/components/content/quickgroup/eventspaces`]: EventSpaces,
  [`mi-aem-groups/components/content/quickgroup/eventreview`]: Review,
  [`mi-aem-groups/components/content/quickgroup/billingandcontact`]: BillingAndContact,
  [`mi-aem-groups/components/content/quickgroup/submitenquiry`]: SubmitInquiry,
  [`mi-aem-groups/components/content/quickgroup/confirmation`]: QuickGroupConfirmation,
  [`mi-aem-groups/components/content/quickgroup/invalidsession`]: InvalidSession,
  [`mi-aem-groups/components/content/quickgroup/eventconfirmationdetails`]: EventConfirmationDetails,
  [`mi-aem-groups/components/content/quickgroup/resubmitrfp`]: ResubmitRfp,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
};

export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, locale, isDtt, isRTL, isDttSwpGroupsEnabled) => {
  MapTo(`mi-aem-common-spa/components/text`)(Text);
  MapTo(`mi-aem-common-spa/components/title`)(Heading);
  MapTo(`mi-aem-common-spa/components/image`)(Container);

  // Import not working so temporary solution
  // Need to remove once platform resolves the import issue
  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',
    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
      />
    );
  }, ExperienceFragmentVariationConfig);

  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(BrandRibbon);
  MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
    <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
  MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(HeroBanner);
  MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(props => (
    <Footer {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered);
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);
  MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainer
      {...props}
      isAuthorMode={isAuthorMode}
      allowedComponents={allowedComponents}
      rtlEnable={isRTL}
    />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
  MapTo(`mi-aem-groups/components/content/shoppingpages/sectionnavigation`)(NavigationMenu);
  MapTo(`mi-aem-groups/components/content/shoppingpages/imagebanner`)(ImageBanner);
  MapTo(`mi-aem-groups/components/content/groupsearchform`)(props =>
    isAuthorMode ? <GroupSearchForm {...props} /> : <GroupSearchFormDynamic {...props} />
  );
  MapTo(`mi-aem-groups/components/content/groupsearch/searchresultsv2`)(props =>
    isAuthorMode ? <SearchForm {...props} /> : <SearchFormDynamic {...props} />
  );
  MapTo(`mi-aem-groups/components/content/groupsearch/searchresults`)(props => (
    <SearchResults {...props} locale={locale} />
  ));
  MapTo(`mi-aem-groups/components/content/rfp/rfptray`)(RfpTray);
  MapTo(`mi-aem-groups/components/content/rfp/header`)(RfpHeader);
  MapTo(`mi-aem-groups/components/content/rfp/eventprofile`)(EventProfile);
  MapTo(`mi-aem-groups/components/content/rfp/eventdetails`)(EventDetails);
  MapTo(`mi-aem-groups/components/content/rfp/contactinformation`)(ContactInfo);
  MapTo(`mi-aem-groups/components/content/rfp/confirmation`)(RfpConfirmation);
  MapTo(`mi-aem-groups/components/content/rfp/eventinfoheader`)(IntlRfpHeader);
  MapTo(`mi-aem-groups/components/content/rfp/eventinfo`)(IntlRfpEventInfo);
  MapTo(`mi-aem-groups/components/content/rfp/paymentheader`)(PreferredPaymentHeader);
  MapTo(`mi-aem-groups/components/content/rfp/preferredpayment`)(PreferredPaymentInfo);
  MapTo(`mi-aem-groups/components/content/rfp/cardInformation`)(PaymentInfo);
  MapTo(`mi-aem-groups/components/content/rfp/preferredpaymentconfirmation`)(PreferredPaymentConfirmation);
  MapTo(`mi-aem-groups/components/content/roominglist/associateheader`)(AssociateHeader);
  MapTo(`mi-aem-groups/components/content/roominglist/roominglistlogin`)(AssociateLogin(isDtt));
  MapTo(`mi-aem-groups/components/content/roominglist/contenttiles`)(DashboardContentTiles);
  MapTo(`mi-aem-groups/components/content/roominglist/searchandfilters`)(SearchAndFilter);
  MapTo(`mi-aem-groups/components/content/roominglist/createeventsummary`)(CreateEventSummary);
  MapTo(`mi-aem-groups/components/content/roominglist/modifyeventsummary`)(ModifyEventSummary);
  MapTo(`mi-aem-groups/components/content/roominglist/eventsummarylist`)(EventSummaryList(isDtt));
  MapTo(`mi-aem-groups/components/content/roominglist/revieweventsummary`)(ConfirmEventSummary(isDtt));
  MapTo(`mi-aem-groups/components/content/roominglist/planner/plannerheader`)(PlannerHeader);
  MapTo(`mi-aem-groups/components/content/roominglist/planner/plannerlogin`)(PlannerLogin);
  MapTo(`mi-aem-groups/components/content/roominglist/planner/eventheading`)(EventHeading);
  MapTo(`mi-aem-groups/components/content/roominglist/planner/search`)(EventSearch);
  MapTo(`mi-aem-groups/components/content/roominglist/planner/plannereventlist`)(PlannerEventList(isDtt));
  MapTo(`mi-aem-groups/components/content/roominglist/planner/plannernewevent`)(PlannerNewEvent(isDtt));
  MapTo(`mi-aem-groups/components/content/roominglist/notification`)(BulletinBoard);
  MapTo(`mi-aem-groups/components/content/reslink/reslinkheader`)(ReslinkAssociateHeader);
  MapTo(`mi-aem-groups/components/content/reslink/contenttile`)(ReslinkDashboardContentTiles);
  MapTo(`mi-aem-groups/components/content/reslink/searchandfilters`)(ReslinkSearchAndFilter);
  MapTo(`mi-aem-groups/components/content/reslink/reslinklist`)(EventList(isDtt));
  MapTo(`mi-aem-groups/components/content/reslink/eventdetails`)(ReslinkEventDetails(isAuthorMode, isDtt));
  MapTo(`mi-aem-groups/components/content/reslink/reslinkguest`)(ReslinkGuest(isDtt));
  MapTo(`mi-aem-groups/components/content/common/emailform`)(ReslinkEmailInfo(isDtt));
  MapTo(`mi-aem-groups/components/content/common/generalerror`)(GeneralError);
  MapTo(`mi-aem-groups/components/content/common/reslinksubmitinvalid`)(GeneralMessage);
  MapTo(`mi-aem-groups/components/content/quickgroup/propertycardheader`)(PropertyHeader);
  MapTo(`mi-aem-groups/components/content/quickgroup/header`)(QuickGroupHeader);
  MapTo(`mi-aem-groups/components/content/quickgroup/guestrooms`)(props => {
    const GuestRoomsComponent = GuestRooms(isDttSwpGroupsEnabled);
    return <GuestRoomsComponent {...props} isAuthorMode={isAuthorMode} />;
  });
  MapTo(`mi-aem-groups/components/content/quickgroup/eventspaces`)(props => (
    <EventSpaces {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-groups/components/content/quickgroup/eventreview`)(Review);
  MapTo(`mi-aem-groups/components/content/quickgroup/billingandcontact`)(BillingAndContact);
  MapTo(`mi-aem-groups/components/content/quickgroup/submitenquiry`)(SubmitInquiry);
  MapTo(`mi-aem-groups/components/content/quickgroup/confirmation`)(QuickGroupConfirmation);
  MapTo(`mi-aem-groups/components/content/quickgroup/invalidsession`)(InvalidSession);
  MapTo(`mi-aem-groups/components/content/quickgroup/eventconfirmationdetails`)(EventConfirmationDetails);
  MapTo(`mi-aem-groups/components/content/quickgroup/resubmitrfp`)(ResubmitRfp);
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
    <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

  MapTo(`mcom-book-spa/components/flyoutcontainer`)(
    props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'FlyoutDrawer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/accountcontainer`)(
    props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'accountcontainer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-account/components/content/signin`)(
    props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'signin',
    }
  );
  MapTo(`mi-aem-account/components/content/signincontentblock`)(
    props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'signincontentblock',
    }
  );
  const DataPageVariationConfig = {
    emptyLabel: 'Data Page',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
    const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
    const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
      />
    );
  }, DataPageVariationConfig);

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.replace(pagePath, '').replace(baseModelPath, '');

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
